export const stateName = 'activate-balance';